/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_OverviewInputs */

const th_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพรวม`)
};

const en_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const ja_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

const es_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const pt_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const id_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan`)
};

const fr_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const tl_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buod`)
};

const vi_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan`)
};

const ko_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개요`)
};

const de_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überblick`)
};

const ru_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const tr_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel bakış`)
};

const it_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const pl_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const uk_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const hi_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सारांश`)
};

const ar_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة`)
};

const ms_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambaran`)
};

const bn_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংক্ষিপ্তসার`)
};

const zh_tw2_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`總覽`)
};

const zh_hk2_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`總覽`)
};

const ur_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جائزہ`)
};

const fa_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نمای کلی`)
};

const sw_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muhtasari`)
};

const nl_tab_overview = /** @type {(inputs: Tab_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Tab_OverviewInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_overview = /** @type {((inputs?: Tab_OverviewInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_OverviewInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_overview(inputs)
	if (locale === "ja") return ja_tab_overview(inputs)
	if (locale === "zh") return zh_tab_overview(inputs)
	if (locale === "es") return es_tab_overview(inputs)
	if (locale === "pt") return pt_tab_overview(inputs)
	if (locale === "id") return id_tab_overview(inputs)
	if (locale === "fr") return fr_tab_overview(inputs)
	if (locale === "tl") return tl_tab_overview(inputs)
	if (locale === "vi") return vi_tab_overview(inputs)
	if (locale === "ko") return ko_tab_overview(inputs)
	if (locale === "de") return de_tab_overview(inputs)
	if (locale === "ru") return ru_tab_overview(inputs)
	if (locale === "tr") return tr_tab_overview(inputs)
	if (locale === "it") return it_tab_overview(inputs)
	if (locale === "pl") return pl_tab_overview(inputs)
	if (locale === "uk") return uk_tab_overview(inputs)
	if (locale === "hi") return hi_tab_overview(inputs)
	if (locale === "ar") return ar_tab_overview(inputs)
	if (locale === "ms") return ms_tab_overview(inputs)
	if (locale === "bn") return bn_tab_overview(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_overview(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_overview(inputs)
	if (locale === "ur") return ur_tab_overview(inputs)
	if (locale === "fa") return fa_tab_overview(inputs)
	if (locale === "sw") return sw_tab_overview(inputs)
	if (locale === "nl") return nl_tab_overview(inputs)
	return en_tab_overview(inputs)
});